import Service from "../Service";

const resource = "delivery/";

export default {
  pagination(params, requestID) {
    return Service.post(resource + "pagination", params, {
      params: { requestID },
    });
  },
  pallets(params, requestID) {
    return Service.post(resource + "pallets", params, {
      params: { requestID },
    });
  },
  summary(params, requestID) {
    return Service.post(resource + "summary", params, {
      params: { requestID },
    });
  },
  detail(params, requestID) {
    return Service.post(resource + "detail", params, {
      params: { requestID },
    });
  },
  report(params, requestID) {
    return Service.post(resource + "report", params, {
      params: { requestID },
    });
  },
  excel(obj, requestID) {
    return Service.post(resource + "excel", obj, {
      params: { requestID: requestID },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  report_container(dtr, requestID){
    return Service.post(resource + "report_container", dtr, {
      params: { requestID },
    });
  },
  excel_container(dtr, requestID) {
    return Service.post(resource + "excel_container", dtr, {
      params: { requestID: requestID },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
};
